import { Button } from 'alurkerja-ui';
import React, { useCallback, useEffect, useRef } from 'react';
import { BiSolidShow } from 'react-icons/bi';
import { Drawer, DrawerRef } from '@/components/shared/panel/Drawer';
import { OverviewTestRunDetail } from '@/pages/testRunDetail/OverviewTestRunDetail';
import { useSearchParams } from 'react-router-dom';

type DetailTestRunModalProps = {
  tesRunDetailId: string;
  onSuccess?: () => void;
  toClose?: () => void;
};

const DetailTestRunModal: React.FC<DetailTestRunModalProps> = ({
  tesRunDetailId,
  onSuccess,
  toClose,
}) => {
  const [searchParams] = useSearchParams();
  const ref = useRef<DrawerRef>(null);

  // Setiap baris punya instance-nya sendiri, jadi drawer hanya dibuka oleh
  // baris yang id-nya sama dengan ?test-run-detail-id. Tanpa perbandingan ini
  // baris pertama yang ter-mount ikut membuka detail milik baris lain.
  useEffect(() => {
    const testRunDetailIdFromParams = searchParams.get('test-run-detail-id');

    if (testRunDetailIdFromParams === tesRunDetailId) {
      ref.current?.open();
    }
  }, [searchParams, tesRunDetailId]);

  // OverviewTestRunDetail memanggil ini dari dalam useEffect, jadi identitasnya
  // harus stabil supaya tidak memicu render berulang.
  const handleErrorDetail = useCallback((isError: boolean) => {
    if (isError) {
      ref.current?.close();
    }
  }, []);

  return (
    <>
      <Button
        onClick={() => {
          ref.current?.open();

          const url = new URL(window.location.href);
          url.searchParams.set('test-run-detail-id', tesRunDetailId);
          window.history.pushState({}, '', url.toString());
        }}
      >
        <BiSolidShow size={20} />
      </Button>

      <Drawer ref={ref}>
        <OverviewTestRunDetail
          id={tesRunDetailId}
          backAction={() => {
            ref.current?.close();
          }}
          onSuccess={onSuccess}
          toClose={toClose}
          setIsErrorDetail={handleErrorDetail}
        />
      </Drawer>
    </>
  );
};

export default DetailTestRunModal;
